/**
 * checks the script included
 */
export default function isScriptIncluded(src) {
    var scripts = document.getElementsByTagName("script");
    for(var i = 0; i < scripts.length; i++) 
        if(scripts[i].getAttribute('src') === src) return true;
    return false;
}